import type { CustomerStore, CustomerKidDiscipline } from './interfaces'

export const getters = {
  getCustomer: (state: CustomerStore): CustomerStore['customer'] => state.customer,
  hasCustomer: (state: CustomerStore): boolean => !!state.customer,
  getCustomerKidDisciplines: (state: CustomerStore): CustomerKidDiscipline[] => {
    if (!state.customer) return []

    return state.customer.kids.flatMap(kid =>
      kid.disciplines.map(discipline => ({
        id: discipline.id,
        code: discipline.code,
        kidId: kid.id,
        kidName: kid.name,
      })),
    )
  },
}